@if (type === 'item') {
    <ion-item (click)="chooseType()">
        <ion-input label="{{ 'Add team match template' | translate }}" label-placement="floating" readonly type="text" [value]="templateName"></ion-input>
    </ion-item>
} @else if (type === 'button') {
    <ion-button (click)="chooseType()">
        {{ 'Use template' | translate }}
    </ion-button>
}